import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ProfileFieldBase from './ProfileFieldBase';
import moment from 'moment-timezone';
import MaskedInput from 'react-maskedinput';

class ProfileDateField extends Component {
  static propTypes = {
    action: PropTypes.func.isRequired,
    editable: PropTypes.bool,
    fieldData: PropTypes.string,
  };

  formatDisplayData = actualData => {
    if (!/Android/i.test(navigator.userAgent) && actualData && moment.utc(actualData).isValid()) {
      return moment.utc(actualData).format('MM/DD/YYYY');
    } else {
      return actualData;
    }
  };

  validate = editData => {
    const errors = [];
    const momentEditData = moment.utc(editData);

    if (!/[0-9]{2}\/[0-9]{2}\/[0-9]{4}/.test(editData)) {
      errors.push('Please enter the date in the MM/DD/YYYY format.');
    }

    if (!momentEditData.isValid()) {
      errors.push('Please enter a valid date.');
    }

    if (!momentEditData.isBefore(moment.now())) {
      errors.push('Please enter a date from the past.');
    }

    return errors;
  };

  render = () => {
    const isAndroid = /Android/i.test(navigator.userAgent);
    const inputTagAttributes = {
      type: 'text',
      placeholder: 'mm/dd/yyyy',
    };

    if (!isAndroid) {
      inputTagAttributes.mask = '11/11/1111';
    }

    return (
      <ProfileFieldBase
        inputTag={!isAndroid ? MaskedInput : 'input'}
        inputTagAttributes={inputTagAttributes}
        validateMethod={this.validate}
        formatDisplayData={this.formatDisplayData}
        {...this.props}
      />
    );
  };
}

export default ProfileDateField;



// WEBPACK FOOTER //
// ./src/subscription/profile/components/ProfileDateField.js